import { Form, Field, ErrorMessage, configure } from "vee-validate";
import { localize, setLocale } from "@vee-validate/i18n";
import en from "@vee-validate/i18n/dist/locale/en.json";
import ja from "@vee-validate/i18n/dist/locale/ja.json";
import * as yup from "yup";
import { setLocale as yupSetLocale } from "yup"; // @vee-validate/i18nのsetLocaleと被るので、別名指定をしています。
import { suggestive } from "yup-locale-ja";

export default defineNuxtPlugin((nuxtApp) => {
  configure({
    generateMessage: localize({
      ja,
    }),
  });

  nuxtApp.vueApp.component("VForm", Form);
  nuxtApp.vueApp.component("VField", Field);
  nuxtApp.vueApp.component("VErrorMessage", ErrorMessage);
  nuxtApp.provide("yup", yup);
  setLocale("ja");
  localize("ja");
  yupSetLocale(suggestive);
});
